import { api } from '../api';

// ApiResponse envelope → inner payload.
const unwrap = (r) => r?.data?.data ?? r?.data;

/**
 * Organization-level profile settings (Settings → Organization).
 *
 * Currently the dealership timezone, which standardises how the whole platform
 * renders wall-clock times (default Australian Eastern time).
 */
export default {
  get:        ()     => api.get('/v1/organization-settings').then(unwrap),
  update:     (body) => api.put('/v1/organization-settings', body).then(unwrap),
  /** [{ id, label, offset }] — AU zones first. For the timezone picker. */
  timezones:  ()     => api.get('/v1/organization-settings/timezones').then(unwrap),
};
